import React from 'react'
import { CloseIcon } from '../../../_components'
import { toast } from 'react-toastify'

export const removeErrorDisplay = (type, errors, setErrors) => {
  if ( !type || !errors || !setErrors ) return

  const typeNameToErrorName = type.split('_')

  if ( typeNameToErrorName[1] ) {
    const errorTypeName = typeNameToErrorName[0] + typeNameToErrorName[1].charAt(0).toUpperCase() + typeNameToErrorName[1].slice(1)
    setErrors({...errors, [errorTypeName]: false})
  } else {
    setErrors({...errors, [`dispatcher${type}`]: false})
  }
}

export const validateFields = (fields, errors, setErrors, queryType) => {
  setErrors({})
  
  let cachedErrors = errors || {}

  let areTitleValid = validateTitle(fields, cachedErrors, setErrors)
  let areFiltersValid = validateFilters(fields, cachedErrors, setErrors)
  let areChannelValid = validateChannel(fields, cachedErrors, setErrors)
  let areTriggersValid = true

  const isWeekDaysValid = ( ( data, errors, setErrors ) => {
    if ( !data.worktime ) return true
    const areWeekDays = !!data.worktime.weekdays?.length
    const areStartAt = !!data.worktime.start_at
    const areStopAt = !!data.worktime.stop_at
    const areSomeThing = areWeekDays || areStartAt || areStopAt
    const areEveryField = areWeekDays && areStartAt && areStopAt

    if ( areSomeThing && !areEveryField ) {
      const weekDaysWeekDaysError = !areWeekDays
      const weekDaysStartAtError = !areStartAt
      const weekDaysStopAtError = !areStopAt
      setErrors( { ...errors, weekDaysWeekDaysError, weekDaysStartAtError, weekDaysStopAtError } )
      return false
    }

    return true
  } )( fields, cachedErrors, setErrors )

  if ( queryType === "momentum" ) {
    areTriggersValid = validateTriggers(fields, cachedErrors, setErrors)
  }
  
  if ( !areTitleValid || !areFiltersValid || !areTriggersValid || !areChannelValid || !isWeekDaysValid ) {
    toast.warn(<><CloseIcon /> Preencha todos os campos corretamente</>, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'toast--white toast--error'
    })

    window.scrollTo(0, 0);
    return false
  }

  return true
}

const validateTitle = (fields, errors, setErrors) => {
  let hasErrors = false

  if ( !fields.momentum_title ) {
    errors.momentumTitle = true
    hasErrors = true
  }

  if ( hasErrors ) {
    return false
  }
  return true
}

const validateFilters = (fields, errors, setErrors) => {
  let hasErrors = false

  if ( !fields.filter ) {
    setErrors({...errors, filterType: true})
    errors.filterType = true
    hasErrors = true
  } else {
    if ( fields.filter.filter !== "all" ) {
      if ( !fields.filter.comparation ) {
        errors.filterComparation = true
        hasErrors = true
      }
      if ( !fields.filter.value ) {
        errors.filterValue = true
        hasErrors = true
      }
    }
  }

  if ( hasErrors ) {
    return false
  }
  return true
}

const validateTriggers = (fields, errors, setErrors) => {
  let hasErrors = false

  if ( !fields.trigger ) {
    setErrors({...errors, triggerType: true})
    errors.triggerType = true
    hasErrors = true
  } else {
    const conditions = {
      "abandon": () => abandonValidation(),
      "pageview": () => pageviewValidation(),
      "events": () => eventsValidation()
    }

    const validate = conditions[fields.trigger.filter]
    if ( !validate ) return false

    validate()
  }

  function abandonValidation() {
    // keep
  }

  function eventsValidation() {
    // keep
  }

  function pageviewValidation() {
    if ( !fields.trigger.comparation ) {
      errors.triggerComparation = true
      hasErrors = true
    }

    if ( !fields.trigger.value || fields.trigger.value.length === 0 ) {
      setErrors({...errors, triggerValue: true})
      errors.triggerValue = true
      hasErrors = true
    } else {
      if ( fields.trigger.comparation === '!=' || fields.trigger.comparation === "==" ) {
        const urlPattern = new RegExp('^(https?:\\/\\/)?'+
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
        '((\\d{1,3}\\.){3}\\d{1,3}))'+
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
        '(\\?[;&a-z\\d%_.~+=-]*)?'+
        '(\\#[-a-z\\d_]*)?$','i')

        for ( const value of fields.trigger.value ) {
          if ( !!urlPattern.test(value) === false ) {
            setErrors({...errors, triggerValue: "urlError"})
            errors.triggerValue = true
            hasErrors = true
          }
        }
      }
    }
  }

  if ( hasErrors ) {
    return false
  }
  return true
}

const validateChannel = (fields, errors, setErrors) => {
  let hasErrors = false

  if ( !fields.dispatcher ) {
    setErrors({...errors, dispatcherType: true})
    errors.dispatcherType = true
    hasErrors = true
  } else {
    const conditions = {
      "CELL_NOTIFICATION": () => cellChannel(),
    }

    const validate = conditions[fields.dispatcher.filter]
    if ( !validate ) return false

    validate()
  }

  function cellChannel() {
    if ( !fields.dispatcher.title ) {
      errors.dispatchertitle = true
      hasErrors = true
    }

    if ( !fields.dispatcher.message ) {
      errors.dispatchermessage = true
      hasErrors = true
    }

    if ( !fields.dispatcher.redirect_uri ) {
      setErrors({...errors, redirectUri: true})
      errors.redirectUri = true
      hasErrors = true
    } else {
      const urlPattern = /^([a-z][a-z0-9+.-]*):(?:\/\/((?:(?=((?:[a-z0-9-._~!$&'()*+,;=:]|%[0-9A-F]{2})*))(\3)@)?(?=(\[[0-9A-F:.]{2,}\]|(?:[a-z0-9-._~!$&'()*+,;=]|%[0-9A-F]{2})*))\5(?::(?=(\d*))\6)?)(\/(?=((?:[a-z0-9-._~!$&'()*+,;=:@/]|%[0-9A-F]{2})*))\8)?|(\/?(?!\/)(?=((?:[a-z0-9-._~!$&'()*+,;=:@/]|%[0-9A-F]{2})*))\10)?)(?:\?(?=((?:[a-z0-9-._~!$&'()*+,;=:@/?]|%[0-9A-F]{2})*))\11)?(?:#(?=((?:[a-z0-9-._~!$&'()*+,;=:@/?]|%[0-9A-F]{2})*))\12)?$/i
      
      if ( !urlPattern.test(fields.dispatcher.redirect_uri) ) {
        setErrors({...errors, redirectUri: "urlError"})
        errors.redirectUri = true
        hasErrors = true
      }
    }
  }

  if ( hasErrors ) {
    return false
  }
  return true
}